import { produce } from "immer";

// Action Types
const ADD_FILE = "ADD_FILE";
const REMOVE_FILE = "REMOVE_FILE";
const REMOVE_FILES = "REMOVE_FILES";
const RESET_FILES = "RESET_FILES";
const ADD_PATH_URL = "ADD_PATH_URL";
const RESET_PATH_URLS = "RESET_PATH_URLS";

// Action Creators
export const addFile = (mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, file_info) => ({
    type: ADD_FILE,
    payload: { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, file_info },
});

export const removeFile = (mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, fileIndex) => ({
    type: REMOVE_FILE,
    payload: { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, fileIndex },
});

export const removeFiles = (mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq) => ({
    type: REMOVE_FILES,
    payload: { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq },
});

export const addPathUrl = (mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, fileIndex, file_path, file_name) => ({
    type: ADD_PATH_URL,
    payload: { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq, fileIndex, file_path, file_name },
});

export const resetPathUrls = (mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq) => ({
    type: RESET_PATH_URLS,
    payload: { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq },
});

export const resetFiles = () => ({
    type: RESET_FILES,
});

const initialState = {};

export default function allTabfileReducer(state = initialState, action) {
    return produce(state, (draft) => {
        const { mmbrSeq, orderNoSeq, scheduleSeq, homeworkNoSeq } = action.payload || {};
        switch (action.type) {
            // 파일 저장
            case ADD_FILE:
                if (!draft[mmbrSeq]) {
                    draft[mmbrSeq] = {};
                }

                if (!draft[mmbrSeq][orderNoSeq]) {
                    draft[mmbrSeq][orderNoSeq] = {};
                }

                if (!draft[mmbrSeq][orderNoSeq][scheduleSeq]) {
                    draft[mmbrSeq][orderNoSeq][scheduleSeq] = {};
                }

                if (!draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq]) {
                    draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq] = [];
                }

                draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq].push({
                    file_info: action.payload.file_info,
                    file_path: null,
                    file_name: null,
                });
                break;

            // 파일 제거
            case REMOVE_FILE:
                if (Array.isArray(draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq])) {
                    draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq].splice(action.payload.fileIndex, 1);
                }
                break;

            // 파일 제거(homeworkNoSeq 별)
            case REMOVE_FILES:
                if (Array.isArray(draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq])) {
                    draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq] = [];
                }
                break;

            // PATH_URL 저장
            case ADD_PATH_URL:
                const findItem = draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq][action.payload.fileIndex];
                findItem.file_path = action.payload.file_path;
                findItem.file_name = action.payload.file_name;
                break;

            // PATH_URL 리셋(모두)
            case RESET_PATH_URLS:
                const findSchedule = draft[mmbrSeq][orderNoSeq][scheduleSeq];
                const findHomeworkNo = draft[mmbrSeq][orderNoSeq][scheduleSeq][homeworkNoSeq];

                if (findSchedule && findHomeworkNo) {
                    findHomeworkNo.forEach((file) => {
                        file.file_path = null;
                        file.file_name = null;
                    });
                }
                break;

            // 초기화
            case RESET_FILES:
                return initialState;

            default:
                break;
        }
    });
}
